import { memo } from 'react';
import type { AddSegmentMenuOptionsProps } from './types';
import Icon from '@/components/atoms/Icon';

function AddSegmentMenuOptions({
  onUploadFileClick,
  onTransitionClick,
  isTransitionApplied,
  canToggleTransition,
  showUploadOption = true
}: AddSegmentMenuOptionsProps) {
  return (
    <div className="flex w-full flex-col gap-0">
      {showUploadOption && (
        <button
          type="button"
          className="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm text-slate-700 hover:bg-slate-100"
          onClick={onUploadFileClick}
          data-testid="add-segment-upload-file"
        >
          <Icon name="IconUpload" className="size-4" />
          Add Video
        </button>
      )}
      {canToggleTransition && (
        <button
          type="button"
          className="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-left text-sm text-slate-700 hover:bg-slate-100"
          onClick={onTransitionClick}
          data-testid="add-segment-transition-toggle"
        >
          <Icon name="IconSwitchHorizontal" className="size-4" />
          {isTransitionApplied ? 'Remove transition' : 'Add transition'}
        </button>
      )}
    </div>
  );
}

export default memo(AddSegmentMenuOptions);
